import React from "react";

export default function OtpInput({
  otp,
  onChange,
  onKeyDown,
  onVerify,
  otpRefs,
  otpError,
  updating,
}) {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-5 space-y-4 shadow-sm">
      <div className="text-center space-y-1">
        <h3 className="font-bold text-gray-900 text-base">
          Enter Buyer's Code
        </h3>
        <p className="text-xs text-gray-500">
          Ask buyer for their 4-digit confirmation code:
        </p>
      </div>

      <div className="flex justify-center gap-3 py-2">
        {otp.map((digit, index) => (
          <input
            key={index}
            ref={otpRefs[index]}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            onChange={(e) => onChange(index, e.target.value)}
            onKeyDown={(e) => onKeyDown(index, e)}
            className="w-12 h-14 text-center text-xl font-bold rounded-xl border border-gray-300 focus:border-green-500 focus:ring-2 focus:ring-green-500/20 bg-gray-50 focus:bg-white transition-all outline-none"
          />
        ))}
      </div>

      {otpError && (
        <p className="text-xs text-red-500 text-center font-medium">
          {otpError}
        </p>
      )}

      <button
        onClick={onVerify}
        disabled={updating || otp.join("").length !== 4}
        className="w-full py-3.5 rounded-xl bg-green-600 text-white font-bold text-sm hover:bg-green-700 active:scale-95 transition-all shadow-sm disabled:opacity-50"
      >
        {updating ? "Verifying..." : "Verify Code"}
      </button>
    </div>
  );
}
